import React, { useEffect, useState } from 'react'
import { H3 } from '../../../../common/H3'
import DurationSelector from '../../../PolicyDuration/components/DurationSelector'
import PolicyDateTimePicker from 'components/PolicyDateTimePicker'

const QuoteParametersForm = () => {
  return (
    <div>
      <H3>How long do you need cover for?</H3>
      <DurationSelector />
      <H3>When would you like cover to start?</H3>
      <PolicyDateTimePicker />
    </div>
  )
}

export default QuoteParametersForm
